import { MeasuringDeviceRow } from 'components/tables/data/measuring-device/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the measuring device id.
 */
export default function MeasuringDeviceIdColumn({ data: { measuringDeviceId } }: { data: MeasuringDeviceRow }) {
  return <P3Regular color="gray.8">{measuringDeviceId}</P3Regular>;
}
